import Notifier from './Esearcher/Ui/Notifier';
    const widget = {
        handleChunkLoadError(error) {
            if (error.name === 'ChunkLoadError') {
                console.warn(error.message);
                $(document).trigger('chunkLoadErrorOccured', [error])
            } else {
                throw error;
            }
        },
        async loadOne(name, node) {
            const self = this;
            const extParts = /^ext_([^_]+)_(.*)/.exec(name);
            if (extParts !== null) {
                const ext = extParts[1].replace(/^[a-z]|-[a-z]/g, x => x.toUpperCase().replace('-', ''));
                const path = extParts[2].replace(/_/g, '/');
                await import(`../ext/${ext}/scripts-widgets/${path}.js`).catch(err => self.handleChunkLoadError(err));
            } else {
                const path = name.replace(/_/g, '/');
                await import(`./widget/${path}.js`).catch(err => self.handleChunkLoadError(err));
            }
            if (typeof $.esearcher !== 'undefined' && typeof $.esearcher[name] !== 'undefined') {
                node[name]();
            }
        },
        parse() {
            const self = this;
            const all = [];
            $("[widget]:not([widgetId])").each(function() {
                const node = $(this);
                const name = node.attr('widget').replace(/^esearcher\./, '');
                if (name !== '') {
                    all.push(self.loadOne(name, node));
                }
            });
            return Promise.all(all);
        },
        getById(id) {
            if (typeof id === 'undefined') {
                console.log('Couldn\'t get widget, got no id');
                return;
            }
            var widget = $('[widgetid="' + id + '"]');
            if (widget.length === 0) {
                console.log('Couldn\'t get widget with id ' + id);
                // Workaround: remove the dialog slider to make the system useable again.
                var backdrop = $('.modal-backdrop');
                if (backdrop.length === 1) {
                    backdrop.remove();
                    $('.dialog.modal.fade.in').remove();
                    var notifier = Notifier.getInstance();
                    var errorText = 'Es ist ein Problem aufgetreten, bitte versuchen Sie es erneut.';
                    notifier.notify(errorText, Notifier.TYPE_ERROR);
                }
                return;
            }
            var widgetClassName = widget.attr('widget');
            var str = widgetClassName.split('.');
            var jqueryConformClassName = str[0];
            var version = parseInt($.ui.version.split('.').join(''));
            if (version > 190) {
                jqueryConformClassName += '-' + str[1];
            }
            else {
                jqueryConformClassName += str[0].substring(0, 1).toUpperCase() + str[0].substring(1, str[0].Length);
            }
            var object = widget.data(jqueryConformClassName);
            return object;
        },
    };

window.widget = widget;

$(function () {
    widget.parse();

    $(document).on('loadFinish', function () {
        widget.parse();
    });
});
